// Налаштування Telegram Mini App при старті.
// Без цього Telegram малює свою шапку й нижню панель кольорами теми (у світлій — білими).

const APP_BG = "#101622";

export function setupTelegramApp() {
  const tg = window.Telegram?.WebApp;
  if (!tg?.initData) return; // відкрито не як Mini App (звичайний браузер)

  const supports = (version) => tg.isVersionAtLeast?.(version);

  try {
    tg.ready();
    tg.expand();

    // Довільний колір шапки — з Bot API 6.9; фон — з 6.1; нижня панель — з 7.10
    if (supports("6.1")) tg.setBackgroundColor(APP_BG);
    if (supports("6.9")) tg.setHeaderColor(APP_BG);
    else if (supports("6.1")) tg.setHeaderColor("bg_color");
    if (supports("7.10")) tg.setBottomBarColor(APP_BG);
  } catch (e) {
    console.warn("Telegram WebApp setup failed", e);
  }
}
